import React     from 'react';

import * as images       from 'images/';
import MenuItem          from 'components/MenuItem';
import JustOrders        from 'Passenger/components/Orders';

export const Orders : React.FC<{}> = props => {
    return (
        <MenuItem title={["Orders ",<a key='download' href='/api/passenger/orders?csv'><images.Download/></a>]}>
            <JustOrders/>
        </MenuItem>
    );
}

export default Orders;